import { useEffect, useState, useCallback } from 'react';
import { listShopIndex, shopHistory, getCode, setCode, clearCode, lockMessage } from '../api/lionjob';

// SỨC KHOẺ SHOP ETSY — chỉ số cào từ Shop Manager bằng extension 📊.
// Mỗi shop 1 bản ghi/ngày; bấm vào shop để xem xu hướng.
const N = (v, d = 0) => (v == null ? '—' : new Intl.NumberFormat('vi-VN', { maximumFractionDigits: d }).format(v));
const money = (v, cur) => (v == null ? '—' : `${new Intl.NumberFormat('en-US', { maximumFractionDigits: 2 }).format(v)} ${cur || ''}`.trim());

// Ngưỡng cảnh báo — theo tiêu chuẩn Star Seller của Etsy.
const health = (r) => {
  const bad = [];
  if (r.reviewAvg != null && r.reviewAvg < 4.8) bad.push(`Sao ${r.reviewAvg} < 4.8`);
  if (r.responseRate != null && r.responseRate < 95) bad.push(`Phản hồi ${r.responseRate}% < 95%`);
  if (r.conversionRate != null && r.conversionRate < 1) bad.push(`Chuyển đổi ${r.conversionRate}% thấp`);
  if (r.openCases) bad.push(`${r.openCases} khiếu nại đang mở`);
  if (r.lateShipments) bad.push(`${r.lateShipments} đơn giao muộn`);
  return bad;
};

export default function ShopIndexPage() {
  const [unlocked, setUnlocked] = useState(false);
  const [codeInput, setCodeInput] = useState('');
  const [lockErr, setLockErr] = useState('');
  const [unlocking, setUnlocking] = useState(false);

  const [rows, setRows] = useState([]);
  const [hist, setHist] = useState(null);
  const [msg, setMsg] = useState('');
  const [extReady, setExtReady] = useState(false);

  const load = useCallback(async () => {
    try {
      const d = await listShopIndex();
      setRows(d.rows); setUnlocked(true);
    } catch (e) {
      const m = e.response?.data?.message || e.message || 'Không kết nối được backend';
      if (e.response?.status === 403) { clearCode(); setUnlocked(false); }
      setLockErr(lockMessage(e)); setMsg('Lỗi: ' + m);
    }
  }, []);

  useEffect(() => { if (getCode()) load(); /* eslint-disable-next-line */ }, []);
  useEffect(() => {
    const onMsg = (ev) => { if (ev.source === window && ev.data?.source === 'lionjob-ext' && ev.data.type === 'ready') setExtReady(true); };
    window.addEventListener('message', onMsg);
    window.postMessage({ source: 'lionjob-page', type: 'ping' }, '*');
    return () => window.removeEventListener('message', onMsg);
  }, []);

  async function unlock(e) {
    e?.preventDefault();
    const c = codeInput.trim(); if (!c) { setLockErr('Nhập mã code'); return; }
    setLockErr(''); setCode(c); setUnlocking(true);
    try { await load(); } finally { setUnlocking(false); }
  }
  async function openHist(shop) {
    try { setHist(await shopHistory(shop)); }
    catch (e) { setMsg('Chưa có lịch sử: ' + (e.response?.data?.message || e.message)); }
  }

  if (!unlocked) {
    return (
      <div className="si-root"><style>{CSS}</style>
        <div className="si-lock"><div className="si-lockCard">
          <div className="si-lockIco">🦁</div><h2>Sức khoẻ shop</h2>
          <p className="si-lockSub">Khu vực chỉ dành cho Giám đốc. Nhập mã code để mở.</p>
          <form onSubmit={unlock}>
            <input className="si-lockInput" type="password" autoFocus placeholder="Mã code" disabled={unlocking}
              value={codeInput} onChange={(e) => setCodeInput(e.target.value)} />
            <button className="si-btn primary" type="submit" disabled={unlocking} style={{ width: '100%', marginTop: 10 }}>
              {unlocking ? '⏳ Đang kết nối…' : 'Mở khóa'}</button>
          </form>
          {lockErr && <div className="si-lockErr">⚠ {lockErr}</div>}
        </div></div>
      </div>
    );
  }

  return (
    <div className="si-root"><style>{CSS}</style>
      <div className="si-head">
        <div>
          <h2>Sức khoẻ shop Etsy</h2>
          <div className="si-sub">{msg || `${rows.length} shop · số liệu đọc từ Shop Manager bằng extension 📊, mỗi shop lưu 1 bản/ngày.`}</div>
        </div>
        <div className="si-sp" />
        <button className="si-btn" onClick={load}>↻ Tải lại</button>
      </div>

      {rows.length === 0 ? (
        <div className="si-empty">
          <div style={{ fontSize: 34, marginBottom: 8 }}>📊</div>
          <b>Chưa có shop nào</b>
          <p>Mở <b>Etsy → Shop Manager → Dashboard</b>, bấm icon <b>🦁</b> →
            <b> “📊 Đọc chỉ số shop Etsy”</b> → <b>Lưu về Lionjob</b>.
            Làm lần lượt ở Dashboard, Stats, Finances để gom đủ chỉ số trong ngày.</p>
          {!extReady && <p className="si-warn">Chưa thấy extension 🦁 — cài extension trước.</p>}
        </div>
      ) : (
        <div className="si-grid">
          {rows.map((r) => {
            const bad = health(r);
            return (
              <div key={r.id} className={'si-card' + (bad.length ? ' warn' : '')} onClick={() => openHist(r.shop)}>
                <div className="si-top">
                  <b className="si-name">{r.shop}</b>
                  {r.starSeller && <span className="si-chip ok">★ Star Seller</span>}
                  <span className="si-day">{r.day}</span>
                </div>
                <div className="si-mets">
                  <M k="Lượt truy cập" v={N(r.visits)} />
                  <M k="Đơn" v={N(r.orders)} />
                  <M k="Doanh thu" v={money(r.revenue, r.currency)} wide />
                  <M k="Chuyển đổi" v={r.conversionRate != null ? r.conversionRate + '%' : '—'} />
                  <M k="Sao" v={r.reviewAvg != null ? `${r.reviewAvg} (${N(r.reviewCount)})` : '—'} />
                  <M k="Phản hồi" v={r.responseRate != null ? r.responseRate + '%' : '—'} />
                  <M k="Số dư" v={money(r.balance, r.currency)} />
                  <M k="Listing" v={N(r.activeListings)} />
                </div>
                {bad.length > 0 && (
                  <div className="si-bad">
                    {bad.map((b) => <span key={b} className="si-chip dang">{b}</span>)}
                  </div>
                )}
                <div className="si-foot">
                  {r.period && <span>{r.period}</span>}
                  <span className="si-pages">{(r.pagesSeen || []).join(' · ') || 'chưa rõ trang'}</span>
                </div>
              </div>
            );
          })}
        </div>
      )}

      {hist && (
        <div className="si-modal" onClick={() => setHist(null)}>
          <div className="si-box" onClick={(e) => e.stopPropagation()}>
            <h3>Xu hướng · {hist.shop}</h3>
            {hist.rows.length < 2 && <p className="si-note">Mới có {hist.rows.length} ngày — cào thêm vài ngày nữa sẽ thấy xu hướng.</p>}
            <div className="si-tblwrap">
              <table className="si-tbl">
                <thead><tr><th>Ngày</th><th>Truy cập</th><th>Đơn</th><th>Doanh thu</th><th>Chuyển đổi</th><th>Sao</th></tr></thead>
                <tbody>
                  {[...hist.rows].reverse().map((h) => (
                    <tr key={h.day}>
                      <td>{h.day}</td><td>{N(h.visits)}</td><td>{N(h.orders)}</td>
                      <td>{N(h.revenue, 2)}</td><td>{h.conversionRate != null ? h.conversionRate + '%' : '—'}</td>
                      <td>{h.reviewAvg ?? '—'}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
            <button className="si-btn" style={{ marginTop: 12 }} onClick={() => setHist(null)}>Đóng</button>
          </div>
        </div>
      )}
    </div>
  );
}

function M({ k, v, wide }) {
  return <div className={'si-m' + (wide ? ' wide' : '')}><div className="si-mk">{k}</div><div className="si-mv">{v}</div></div>;
}

const CSS = `
.si-root{color:var(--text);padding-bottom:30px}
.si-head{display:flex;gap:10px;align-items:flex-start;margin-bottom:14px;flex-wrap:wrap}
.si-head h2{margin:0;font-size:20px}
.si-sub{color:var(--muted);font-size:12.5px;margin-top:3px;max-width:72ch}
.si-sp{flex:1}
.si-btn{background:var(--panel);color:var(--text);border:1px solid var(--border);padding:7px 12px;border-radius:9px;cursor:pointer;font-size:13px}
.si-btn:hover{border-color:var(--accent)}
.si-btn.primary{background:var(--accent);border-color:var(--accent);color:#fff;font-weight:600}

.si-empty{border:1px dashed var(--border);border-radius:var(--radius);padding:48px 24px;text-align:center;color:var(--muted)}
.si-empty b{color:var(--text);display:block;margin-bottom:6px}
.si-empty p{font-size:13px;margin:0 auto;max-width:56ch;line-height:1.7}
.si-warn{color:var(--warn);margin-top:10px}

.si-grid{display:grid;grid-template-columns:repeat(auto-fill,minmax(320px,1fr));gap:14px}
.si-card{background:var(--panel);border:1px solid var(--border);border-radius:var(--radius);padding:14px 16px;cursor:pointer;transition:border-color .12s,transform .12s}
.si-card:hover{border-color:var(--accent);transform:translateY(-1px)}
.si-card.warn{border-color:var(--warn)}
.si-top{display:flex;align-items:center;gap:8px;margin-bottom:11px;flex-wrap:wrap}
.si-name{font-size:15px}
.si-day{margin-left:auto;font-family:var(--font-mono);font-size:11px;color:var(--muted)}
.si-mets{display:grid;grid-template-columns:repeat(4,1fr);gap:7px}
.si-m{background:var(--input);border-radius:8px;padding:6px 8px;min-width:0}
.si-m.wide{grid-column:span 2}
.si-mk{font-size:9.5px;letter-spacing:.05em;text-transform:uppercase;color:var(--muted);font-weight:600}
.si-mv{font-family:var(--font-mono);font-size:13px;font-weight:600;margin-top:2px;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}
.si-bad{display:flex;gap:5px;flex-wrap:wrap;margin-top:10px}
.si-chip{font-size:10.5px;font-weight:600;border-radius:5px;padding:2px 7px;border:1px solid var(--border);color:var(--muted)}
.si-chip.ok{color:var(--ok);border-color:var(--ok)}
.si-chip.dang{color:var(--danger);border-color:var(--danger)}
.si-foot{display:flex;gap:8px;margin-top:10px;font-size:11px;color:var(--muted)}
.si-pages{margin-left:auto;font-family:var(--font-mono)}

.si-modal{position:fixed;inset:0;background:rgba(8,11,20,.72);display:flex;align-items:center;justify-content:center;padding:24px;z-index:1000}
.si-box{background:var(--panel);border:1px solid var(--border);border-radius:var(--radius);padding:18px 20px;max-width:760px;width:100%;max-height:86vh;overflow:auto}
.si-box h3{margin:0 0 10px;font-size:15px}
.si-note{color:var(--muted);font-size:12.5px;margin:0 0 10px}
.si-tblwrap{overflow-x:auto}
.si-tbl{width:100%;border-collapse:collapse;font-size:12.5px}
.si-tbl th{text-align:left;color:var(--muted);font-size:10px;letter-spacing:.07em;text-transform:uppercase;padding:6px 8px;border-bottom:1px solid var(--border)}
.si-tbl td{padding:6px 8px;border-bottom:1px solid var(--line);font-family:var(--font-mono)}
.si-tbl tr:last-child td{border-bottom:0}

.si-lock{display:flex;justify-content:center;padding:60px 20px}
.si-lockCard{background:var(--panel);border:1px solid var(--border);border-radius:var(--radius);padding:28px 26px;width:340px;text-align:center}
.si-lockIco{font-size:38px;line-height:1}.si-lockCard h2{margin:8px 0 4px}
.si-lockSub{color:var(--muted);font-size:13px;margin:0 0 16px}
.si-lockInput{width:100%;background:var(--input);color:var(--text);border:1px solid var(--border);border-radius:10px;padding:10px 12px;font-size:14px;text-align:center;letter-spacing:2px}
.si-lockErr{color:var(--danger);font-size:12px;margin-top:10px}
`;
